module.exports = __webpack_public_path__ + "static/media/kermit_typing.88f9589c.gif";